import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  Button,
  Select,
  MenuItem,
  FormControl,
  Divider,
  Stack,
  FormLabel,
  Radio,
  RadioGroup,
  IconButton,
  InputLabel,
    Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import { maskCreditCardNumber } from "../../../Utils/validations-utils";
import closeIconPng from "../../../assets/icon-close.svg";
import { getquickBillPayPageContent } from "../../../SharedContextStore/slices/contents/qbpContentAem";
import { EligiblePaymentOverall, PostpaidFiberContent, QuickBillPay } from "../../../SharedComponents/contents";
import { renderCurrency } from "../../../Utils/utils";
import useBrightspeedUser from "../../../hooks/useUser";
import { setaddPaymentMethodError } from "../../../SharedContextStore/slices/paymentMethods";

const AutoPayMessageNew = (props: any) => {
  const {
    nextPrimaryPaymnetId,
    defaultPayId,
    deletePaymentDetails,
    nextPrimaryMethod,
    defaultPayMethod,
    popupDetails,
  } = useAppSelector((state) => state?.paymentMethodDetails);
  const { addPaymentMethodError } = useAppSelector((state) => state?.paymentMethods);
  const { onCallBack } = props;
  const eligiblePaymentOverall: any = EligiblePaymentOverall();
  const JSONcontent: any = eligiblePaymentOverall?.entry;
  const step2Of3 = JSONcontent?.step2Of3;
  const dispatch = useAppDispatch();

  const { entry: postpaidcontent }: any = PostpaidFiberContent();

  const remove_auto_pay_desc = postpaidcontent?.am_postpaid_fiber_autopay?.remove_auto_pay_desc;
   
  const { isPostPaidFiberUser } = useBrightspeedUser();


  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );

  const QBP_CONTENT_2: any = QuickBillPay();
   useEffect(() => {
    if(!QBP_CONTENT_Data) {
    dispatch(getquickBillPayPageContent());
    }
  }, []);

  const manageautopay = QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay;




  const enrollSuccess = (
    <>
      <Box className={"addNewPaymentMethod"}>
        <Box className="enrollemnt-main">
          <Typography className="modal-title font-primary" component="h2" id="scroll-dialog-title">{manageautopay?.success_popup_header}</Typography>
          <Typography className="modal-description mt-2 pt-1"
          //  id="scroll-dialog-description"
           >
            {manageautopay?.success_popup_desc_line1}
            <Typography className="text-color-primary mt-3 text-spacing">
              {manageautopay?.success_popup_desc_line2}
            </Typography>
            {/* {popupDetails?.paperLessAcceptancekey && ( */}
              <Typography className="modal-description mt-13">
                {manageautopay?.success_popup_email_line1}
                <b>{popupDetails?.paperLessEmailkey}</b>{" "}
                {manageautopay?.success_popup_email_line2}
              </Typography>
            {/* )} */}
          </Typography>
        </Box>
        <Box className="summaryWraper">
          <Box className="summaryTitle">
            <Typography className="text-color-primary font-primary" component="h3"
              style={ {
                fontSize: "19px",
                fontWeight: "600",
                lineHeight: "27px",
              }}
            >
              {manageautopay?.success_popup_acc_summ}
              </Typography>
            <hr role="presentation"/>
          </Box>
          <TableContainer>
          <Table className="detailMain">
          <caption style={{ opacity: "0", position: "absolute" }}>
          {manageautopay?.success_popup_acc_summ}</caption>
            <TableBody>
             <TableRow className="details">
             <TableCell className="p-0 border-0">
              <Typography className="detailsTitle text-color-secondary marbot24">
                {manageautopay?.success_popup_acc_balance}
              </Typography>
              </TableCell>
              <TableCell className="p-0 border-0">
              <Typography className="detailsValue text-color-secondary marbot24">
                {renderCurrency(popupDetails?.balanceAmountKey)}
                
                {/* {"$"}
                {popupDetails?.balanceAmountKey} */}
              </Typography>
              </TableCell>
           </TableRow>
            <TableRow className="details">
            <TableCell className="p-0 border-0">
              <Typography className="detailsTitle text-color-secondary">
                {manageautopay?.payment_method}
              </Typography>
              </TableCell>
              <TableCell className="p-0 border-0">
              <Typography className="detailsValue text-color-secondary">
                {popupDetails?.paymentDetails?.paymentType === "Card"
                  ? popupDetails?.paymentDetails?.creditCardType.charAt(0) +
                    popupDetails?.paymentDetails?.creditCardType
                      .slice(1)
                      .toLowerCase()
                  : popupDetails?.paymentDetails?.type.charAt(0) +
                    popupDetails?.paymentDetails?.type
                      .slice(1)
                      .toLowerCase()}{" "}
                ****{" "}
                {popupDetails?.paymentDetails?.paymentType === "Card"
                  ? maskCreditCardNumber(
                      popupDetails?.paymentDetails?.cardNumber
                    )
                  : popupDetails?.paymentDetails?.bankAccountNumber.slice(12)}
              </Typography>
              </TableCell>
            </TableRow>
            </TableBody>
          </Table>
          </TableContainer>
        </Box>
      </Box>
      <Box>
        <Button
          className="button-alignment enrollSuccessPopupBtn"
          variant="contained"
          color="primary"
          onClick={() => {
            onCallBack("enrollSuccess");
          }}
        >
          {((failButtonValue) => manageautopay?.manage_autopay)()}
        </Button>
        <Stack
          direction="row"
          justifyContent="end"
          className="new-close-icon-cantainer"
        >
          <Box className="closeIcon">
            <Typography component="button" className="buttonText" aria-label="Close the dialog" onClick={() => onCallBack("enrollSuccess")}>
              <img
                src={closeIconPng}
                alt="Close the dialog"
              />
            </Typography>
          </Box>
        </Stack>
      </Box>
    </>
  );

  const enrollFailed = (
      <>
        <Box className={"addNewPaymentMethod"}>
          <Typography className="modal-title font-primary" id="scroll-dialog-title">         
            { manageautopay?.enroll_failure_popup_header}
          </Typography>
          <Typography className="modal-description enroll-failed">
            {`${manageautopay?.enroll_failure_description} `}
            <Typography component={"button"} className="btnText p-0 font-secondary chat-now-button cursor-pointer" 
          aria-label= {"open chatbox"} onClick={()=>{chatClick()}}>{manageautopay?.enroll_failure_chatNow_button}</Typography>
          <>{" " + manageautopay?.enroll_failure_callUs}</>
          </Typography>
        </Box>
        <Box className="paymentMethodButtons">
          <Button
            className="button-alignment"
            variant="contained"
            color="primary"
            onClick={() => 
              {
                onCallBack("enrollFailed");
              }}
          >
            {((failButtonValue) =>  manageautopay?.enroll_failure_cta)()}
          </Button>
        </Box>
        <Stack
            direction="row"
            justifyContent="end"
            className="new-close-icon-cantainer"
          >
            <Box className="closeIcon">
              <Typography component="button" className="buttonText" aria-label="Close the dialog" onClick={() => 
                {
                  onCallBack("enrollFailed");
                }}>
                <img
                  src={closeIconPng}
                  alt="Close the dialog"
                />
              </Typography>
            </Box>
          </Stack>
      </>
    );

  const apiFailed = (
    <>
      <Box className={"addNewPaymentMethod"}>
        <Typography className="modal-title font-primary" id="scroll-dialog-title">
          {/* {`We weren't able to ${
            popupDetails?.selectedCard &&
            popupDetails?.selectedCard === "bankAccount"
              ? "validate your bank account."
              : "validate your card."
          } */}
          {addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? manageautopay?.existing_card_bank_account_header :
            popupDetails?.selectedCard &&
            popupDetails?.selectedCard === "bankAccount"
              ? manageautopay?.not_validate_account
              : manageautopay?.not_validate_card
          }
        </Typography>
        <Typography className="modal-description no-changes-popup"
        //  id="scroll-dialog-description"
         >
          {/**Cvv popup failed message body */}
          {addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? manageautopay?.existing_card_bank_account_desc :
           props?.isUnAuthPa
            ? step2Of3?.cvvInvalid
            : popupDetails?.selectedCard &&
            popupDetails?.selectedCard === "bankAccount"
            ? manageautopay?.pay_method_failed_popup_desc_bank
              : manageautopay?.pay_method_failed_popup_desc
          }
        </Typography>
      </Box>
      <Box className="paymentMethodButtons">
        <Button
          className="button-alignment"
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(setaddPaymentMethodError(""));
            onCallBack("apiFailed")
          }
          }
        >
          {((failButtonValue) => addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? manageautopay?.existing_card_bank_account_cta : manageautopay?.cta_reenter_info)()}
        </Button>
      </Box>
      <Stack
          direction="row"
          justifyContent="end"
          className="new-close-icon-cantainer"
        >
          <Box className="closeIcon">
          <Typography component="button" className="buttonText" aria-label="Close the dialog" onClick={() => {
            dispatch(setaddPaymentMethodError(""));
            onCallBack("apiFailed")
          }
          }
          >
              <img
                src={closeIconPng}
                alt="Close the dialog"
              />
            </Typography>
          </Box>
        </Stack>
    </>
  );

  const paymentSettingSuccess = (
    <>
      <Box className={"addNewPaymentMethod"}>
        <Typography component="h2" className="modal-title font-primary" id="scroll-dialog-title">
          {popupDetails?.anychangesupdated
            ? manageautopay?.success_popup_great_job
            : manageautopay?.not_made_changes}
        </Typography>
        <Typography className="modal-description no-changes-popup" 
        // id="scroll-dialog-description"
        >
          {popupDetails?.anychangesupdated
            ? manageautopay?.success_popup_great_job_desc
            : manageautopay?.make_choice}
        </Typography>
      </Box>
      <Box className="paymentMethodButtons">
        <Button
          className="button-alignment"
          variant="contained"
          color="primary"
          onClick={() =>
            onCallBack(
              popupDetails?.anychangesupdated
                ? "updateAutoPaySuccess"
                : "paymentSettingSuccess"
            )
          }
        >
          {((failButtonValue) =>
            popupDetails?.anychangesupdated
              ? manageautopay?.back_autopay
              : manageautopay?.back)()}
        </Button>
      </Box>
      <Stack
          direction="row"
          justifyContent="end"
          className="new-close-icon-cantainer"
        >
          <Box className="closeIcon">
            <Typography component="button" className="buttonText" aria-label="Close the dialog"
              onClick={() =>
                onCallBack(
                  popupDetails?.anychangesupdated
                    ? "updateAutoPaySuccess"
                    : "paymentSettingSuccess"
                )
              }>
              <img
                src={closeIconPng}
                alt="Close the dialog"
              />
            </Typography>
          </Box>
        </Stack>
    </>
  );
  const disableAutoPay = (
    <>
      <Box className={"addNewPaymentMethod"}>
        <Typography className="modal-title font-primary" component="h2" id="scroll-dialog-title">
          {manageautopay?.disable_autopay}
        </Typography>

        <Typography className="modal-description disableAutoPayDesc"
        //  id="scroll-dialog-description"
         >
          {isPostPaidFiberUser ? remove_auto_pay_desc   : manageautopay?.remove_auto_pay_desc}
        </Typography>
      </Box>
      <Box className="disableAutoPay">
        <Button
          color="primary"
          variant="outlined"
          className="disableAutoPayGoback"
          onClick={() => {
            onCallBack("disableAutoPayCancel");
          }}
        >
          {manageautopay?.cta_go_back}
        </Button>
        <Button
          color="primary"
          variant="contained"
          className="disableAutoPayConfirm"
          onClick={() => {
            onCallBack("disableAutoPaySuccess");
          }}
        >
          {manageautopay?.cta_confirm}
        </Button>
      </Box>
      <Stack
          direction="row"
          justifyContent="end"
          className="new-close-icon-cantainer"
        >
          <Box className="closeIcon">
            <Typography component="button" className="buttonText" aria-label="Close the dialog" onClick={() => {
              onCallBack("disableAutoPayCancel");
            }}>
              <img
                src={closeIconPng}
                alt="Close the dialog"
              />
            </Typography>
          </Box>
        </Stack>
    </>
  );

  switch (popupDetails?.popupName) {
    case "enrollSuccess":
      return enrollSuccess;
    case "enrollFailed":
      return enrollFailed;
    case "apiFailed":
      return apiFailed;
    case "paymentSettingSuccess":
      return paymentSettingSuccess;
    case "disableAutoPay":
      return disableAutoPay;
    default:
      return <></>;
  }
  //return <>{popupName && popupName === "enrollSuccess" && <enrollSuccess />}</>;
};
export default AutoPayMessageNew;
